export const semNumeroNegativoInput = (event, setState) => {
    let input = event.target.value
    if
        (
        !input ||
        (input[input.length - 1].match("[0-9]") && input[0].match("[0-9]"))
    ) {
        return setState(input)
    }
}

export const limitaCaracteres = (event, setState, length) => {
    let input = event.target.value

    if (input.length <= length) {
        if
            (
            !input ||
            (input[input.length - 1].match("[0-9]") && input[0].match("[0-9]"))
        ) {
            return setState(input)
        }
    }
}